import { useGet } from "app/pages/company/Hooks/Api/useGet";
import { useEffect, useRef, useState } from "react";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { getIndividual } from "sr/utils/api/individual/getIndividual";
import { createStripCustomer } from "sr/utils/api/strip/createStripCustomer";
import {
  useStripe,
  useElements,
  CardElement,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";
import { getCardIcon } from "sr/helpers/functions/getCardIcon";
import getStripCustomerId from "sr/helpers/apiFunctions/strip/getStripCustomerId";
import CreateIntent from "sr/helpers/apiFunctions/strip/createIntent";
import { toast } from "react-toastify";
import { deleteCard } from "sr/utils/api/strip/deleteCard";
import { createDefaultCard } from "sr/utils/api/strip/createDefaultCard";
import { getDefaultCard } from "sr/utils/api/strip/getDefaultCard";
import { ModelWrapperWithButton } from "app/pages/company/component/ModelWrapperWithButton";
import { capitalizeFirstLetter } from "sr/helpers/functions/firstletterCapital";
import { setDefaultStripPm } from "sr/utils/api/strip/setDefaultStripPm";
import getCardDetail from "sr/helpers/apiFunctions/strip/getCardDetails";
import { useDispatch } from "react-redux";
import { AppDispatch } from "sr/redux/store";
import { updateReloadSetting } from "sr/redux/reducers/appSettings";

export const PaymentForm = (props) => {
  const [userId, setUserid] = useState();
  const [isProcessing, setIsProcessing] = useState(false);
  const { loader: loader, getData: fetchData, data: data } = useGet();
  const stripe = useStripe();
  const elements = useElements();
  const [cardError, setCardError] = useState(null);
  const [stripId, setStripId] = useState();
  const [defaultCard, setDefaultCard] = useState(null);

  const [showModel, setShowModel] = useState(false);
  const [cardDetails, setCardDetails] = useState<any>([]);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [highlightAllErrors, setHighlightAllErrors] = useState(false);
  const [cardExpiryError, setCardExpiryError] = useState(null);
  const [cardCVCError, setCardCVCError] = useState(null);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const { user_id } = getUserDetails();
    setUserid(user_id);
  }, []);
  const fetchDetails = async (id) => {
    const params = new URLSearchParams();
    if (userId) params.append("id", id);
    await fetchData(() => getIndividual(params));
  };
  const cardnumberElement = useRef(null);
  const cardcvv = useRef(null);
  const cardExpiry = useRef(null);
  useEffect(() => {
    if (!elements) return;

    cardnumberElement.current = elements?.getElement(CardNumberElement);
    if (cardnumberElement) {
    }
    cardcvv.current = elements?.getElement(CardCvcElement);
    cardExpiry.current = elements?.getElement(CardExpiryElement);
  }, [showModel, elements]);

  useEffect(() => {
    if (userId) {
      fetchDetails(userId);
      getStripCustomerId({
        setCardDetails: setCardDetails,
        setIsProcessing: setIsProcessing,
        setStripId: setStripId,
        customerId: userId,
      });
    }
  }, [userId]);
  const onCheckModel = () => {
    if (props?.setShowAddModal) props?.setShowAddModal("wallet");
    dispatch(updateReloadSetting(true));
  };
  const CreateStripCustomer = async (e) => {
    if (!cardnumberElement?.current) {
    }
    e.preventDefault();
    if (stripId) {
      CreateIntent({
        customerId: userId,
        cardnumberElement: cardnumberElement?.current,
        stripe: stripe,
        elements: elements,
        setIsProcessing: setIsProcessing,
        stripId: stripId,
        setCardDetails: setCardDetails,
        email: data?.email,
        currency: "USD",
        cardcvv: cardcvv?.current,
        cardExpiry: cardExpiry?.current,
        setShowModel: setShowModel,
        onCheckModel: onCheckModel,
        setSubmitError: setSubmitError,
        setHighlightAllErrors: setHighlightAllErrors,
      });
    } else {
      const payload = {
        cleanpig_id: userId,
        type: "individual",
      };
      const res = await createStripCustomer(payload);
      if (res?.success === true) {
        if (res?.data?.customer) {
          CreateIntent({
            customerId: userId,
            cardnumberElement: cardnumberElement?.current,
            stripe: stripe,
            elements: elements,
            setIsProcessing: setIsProcessing,
            stripId: res?.data?.customer,
            setCardDetails: setCardDetails,
            email: data?.email,
            currency: "USD",
            cardcvv: cardcvv?.current,
            cardExpiry: cardExpiry?.current,
            setShowModel: setShowModel,
            onCheckModel: onCheckModel,
            setSubmitError: setSubmitError,
            setHighlightAllErrors: setHighlightAllErrors,
          });
        }
      }
    }
  };

  const resetFormErrors = () => {
    setCardError(null);
    setCardExpiryError(null);
    setCardCVCError(null);
    setSubmitError(null);
    setHighlightAllErrors(false);

    cardnumberElement.current?.clear();
    cardExpiry.current?.clear();
    cardcvv.current?.clear();
  };

  const stripeInputStyles = {
    base: {
      "::placeholder": {
        color: "#888", // Placeholder color
      },
    },
    focus: {
      borderColor: "#666", // Border color on focus
    },
    invalid: {
      color: "#e5424d", // Color for invalid input
      borderColor: "#e5424d", // Border color for invalid input
    },
  };
  const handleDelete = async (id) => {
    try {
      setIsProcessing(true);
      const queryParams = new URLSearchParams();
      queryParams.append("method_id", id);
      const res = await deleteCard(queryParams);
      if (res?.success === true) {
        toast.success("Card Deleted Successfully");
        getStripCustomerId({
          setCardDetails: setCardDetails,
          setIsProcessing: setIsProcessing,
          setStripId: setStripId,
          customerId: userId,
        });
        dispatch(updateReloadSetting(true));
      } else {
        setIsProcessing(false);
      }
    } catch (e) {
      setIsProcessing(false);
    }
  };
  useEffect(() => {
    if (props?.type === "popup" && props?.showAddModel) {
      setShowModel(true);
    }
  }, [props?.type, props?.showAddModel]);
  const fetchDefaultCard = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("individual_id", userId);
    try {
      const res = await getDefaultCard(queryParams);
      if (res?.success === true) {
        setDefaultCard(res?.data);
        return true;
      } else {
        return true;
      }
    } catch (e) {
    } finally {
      return true;
    }
  };
  const handleDefault = async (pmId, cardNumber, cardType) => {
    setIsProcessing(true);
    try {
      const payLoad = {
        pmId,
        // individual_id: userId,
        // card: cardNumber,
        // card_type: cardType,
      };
      // const res = await createDefaultCard(payLoad);
      const res = await setDefaultStripPm(payLoad);
      if (res?.success === true) {
        // await fetchDefaultCard();
        await getCardDetail({
          setIsProcessing: setIsProcessing,
          setCardDetails: setCardDetails,
        });
        setIsProcessing(false);
        // window.location.reload();
        dispatch(updateReloadSetting(true));
      } else {
        setIsProcessing(false);
        return null;
      }
    } catch (e: any) {
      setIsProcessing(false);
    }
  };
  useEffect(() => {
    if (userId) {
      // fetchDefaultCard();
    }
  }, [userId]);
  return (
    <>
      {isProcessing && <LoaderFullScreen />}
      <div className="py-3">
        <div className="pb-5">
          {/* <p><span className=""><FormattedMessage id="INDIVIDUAL.SETTINGS.MENU.AVAILABLE.BALANCE.TITLE" defaultMessage="Available Account Balance" />:</span>$0</p>
          <p>*<FormattedMessage id="INDIVIDUAL.SETTINGS.MENU.AVAILABLE.BALANCE.TEXT" defaultMessage="Account balances are automatically applied when a task is Completed" />
      </p> */}
        </div>
      </div>
      <div className=" max-w-[32rem] mx-auto">
        {cardDetails?.map((item) => (
          <div className="flex space-x-3 my-3 px-6 border-neutral-200 border w-full justify-center">
            <div className="border-r border-neutral-200 flex items-center space-x-4 w-[70%]">
              <div>{getCardIcon(item?.card?.brand)}</div>
              <div>
                <div>{capitalizeFirstLetter(item?.card?.brand)}</div>
                <span>**** **** **** {item?.card?.last4}</span>
              </div>
            </div>
            <div className="w-[30%] py-2 flex flex-col space-y-2 justify-center items-center">
              {cardDetails.length > 1 && (
                <p
                  onClick={() => handleDelete(item?.id)}
                  className=" border border-[#d4d2d0]  hover:border-[#0078ae]   flex justify-center items-start w-[8rem] py-[8px] mb-3 cursor-pointer  rounded-lg text-[#0078ae]  "
                >
                  Delete
                </p>
              )}
              {/* {defaultCard?.card === item?.card?.last4 ? ( */}
              {item?.isDefault ? (
                <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  Default
                </span>
              ) : (
                // <p className=" border border-[#d4d2d0]  hover:border-[#0078ae]  flex justify-center items-start w-[8rem] [py-[8px]] cursor-pointer  rounded-lg text-[#0078ae] ">
                //   Default
                // </p>
                <p
                  onClick={() =>
                    handleDefault(
                      item?.id,
                      item?.card?.last4,
                      item?.card?.brand,
                    )
                  }
                  className=" border border-[#d4d2d0]  hover:border-[#0078ae]  flex justify-center items-start w-[8rem] py-[8px] cursor-pointer  rounded-lg text-[#0078ae] font-bold "
                >
                  Set as Default
                </p>
              )}
            </div>
          </div>
        ))}

        <p
          onClick={() => setShowModel(true)}
          className=" text-[#0078ae] font-bold cursor-pointer "
        >
          Add Credit Card
        </p>
      </div>
      <ModelWrapperWithButton
        showModal={showModel}
        onCheckModel={() => {
          resetFormErrors();
          setShowModel(false);
          props?.setShowAddModal && props?.setShowAddModal("");
        }}
        Save={CreateStripCustomer}
      >
        <form>
          {elements ? (
            <>
              <label
                htmlFor="card-number"
                className="block text-normal font-medium  mt-3"
              >
                Card Number:
              </label>

              <div
                id="card-number"
                className={`rounded-lg h-11 mb-3 flex items-center w-full px-2 border ${
                  highlightAllErrors || cardError
                    ? "border-red-500"
                    : "border-zinc-800"
                }`}
              >
                <CardNumberElement
                  options={{ style: stripeInputStyles }}
                  className="w-full"
                  onChange={(event) => {
                    setSubmitError(null);
                    setHighlightAllErrors(false);
                    if (event.error) {
                      setCardError(
                        "The card information you've entered is not correct.  Please verify that the information is correct and try again.",
                      ); // ← Stripe message
                    } else {
                      setCardError(null);
                    }
                  }}
                />
              </div>
              {cardError && (
                <>
                  <div className="text-red-600 text-sm mt-1">{cardError}</div>
                  <br />
                </>
              )}

              <div className="flex space-x-3 w-full">
                <div className="w-1/2">
                  <label
                    htmlFor="card-expiry"
                    className="block text-normal font-medium  "
                  >
                    Expiry Date
                  </label>
                  <div
                    id="card-expiry"
                    className={`rounded-lg h-11 flex items-center w-full px-2 border ${
                      highlightAllErrors || cardExpiryError
                        ? "border-red-500"
                        : "border-zinc-800"
                    }`}
                  >
                    <CardExpiryElement
                      options={{ style: stripeInputStyles }}
                      className="w-full"
                      onChange={(event) => {
                        setSubmitError(null);
                        setHighlightAllErrors(false);
                        if (event.error) {
                          setCardExpiryError(event.error.message);
                        } else {
                          setCardExpiryError(null);
                        }
                      }}
                    ></CardExpiryElement>
                  </div>
                  {cardExpiryError && (
                    <>
                      <div className="text-red-600 text-sm mt-1">
                        {cardExpiryError}
                      </div>
                      <br />
                    </>
                  )}
                </div>
                <div className="w-1/2">
                  <label
                    htmlFor="card-cvc"
                    className="block text-normal font-medium "
                  >
                    CVC
                  </label>

                  <div
                    id="card-cvc"
                    className={`rounded-lg h-11 mb-3 flex items-center w-full px-2 border ${
                      highlightAllErrors || cardCVCError
                        ? "border-red-500"
                        : "border-zinc-800"
                    }`}
                  >
                    <CardCvcElement
                      options={{ style: stripeInputStyles }}
                      className="w-full"
                      onChange={(event) => {
                        setSubmitError(null);
                        setHighlightAllErrors(false);
                        if (event.error) {
                          setCardCVCError(event.error.message);
                        } else {
                          setCardCVCError(null);
                        }
                      }}
                    ></CardCvcElement>
                  </div>
                  {cardCVCError && (
                    <>
                      <div className="text-red-600 text-sm mt-1">
                        {cardCVCError}
                      </div>
                      <br />
                    </>
                  )}
                </div>
              </div>
              {submitError && (
                <div className="text-red-600 text-sm mt-3 text-left">
                  {submitError}
                </div>
              )}
            </>
          ) : (
            <p>Loading payment form...</p>
          )}
        </form>
      </ModelWrapperWithButton>
    </>
  );
};
